var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPercentageTicket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 2C4.89543 2 4 2.90677 4 4.02532V20.2278C4 21.0623 4.94076 21.5387 5.6 21.038L7.4 19.6709C7.75556 19.4008 8.24444 19.4008 8.6 19.6709L11.4 21.7975C11.7556 22.0675 12.2444 22.0675 12.6 21.7975L15.4 19.6709C15.7556 19.4008 16.2444 19.4008 16.6 19.6709L18.4 21.038C19.0592 21.5387 20 21.0623 20 20.2278V4.02532C20 2.90677 19.1046 2 18 2H6ZM9.5 10.1013C8.67157 10.1013 8 9.42119 8 8.58228C8 7.74336 8.67157 7.06329 9.5 7.06329C10.3284 7.06329 11 7.74336 11 8.58228C11 9.42119 10.3284 10.1013 9.5 10.1013ZM15.5303 7.53891C15.8232 7.83551 15.8232 8.31639 15.5303 8.61299L9.53033 14.6889C9.23744 14.9855 8.76256 14.9855 8.46967 14.6889C8.17678 14.3923 8.17678 13.9115 8.46967 13.6149L14.4697 7.53891C14.7626 7.24231 15.2374 7.24231 15.5303 7.53891ZM14.5 15.1646C13.6716 15.1646 13 14.4845 13 13.6456C13 12.8067 13.6716 12.1266 14.5 12.1266C15.3284 12.1266 16 12.8067 16 13.6456C16 14.4845 15.3284 15.1646 14.5 15.1646Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPercentageTicket);
export default __webpack_public_path__ + "static/media/percentage-ticket.8ba2b5d3419f8d883d2fb9935fbdeafd.svg";
export { ForwardRef as ReactComponent };